var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _class, _temp2;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React from 'react';
import PropTypes from "prop-types";
import { RouterLink as Link } from '../Router/';
import ButtonIntl from './ButtonIntl';
import ButtonUpload from './ButtonUpload';

import './Button.scss';

var Button = (_temp2 = _class = function (_React$Component) {
    _inherits(Button, _React$Component);

    function Button() {
        var _temp, _this, _ret;

        _classCallCheck(this, Button);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.renderIcon = function () {
            var icon = _this.props.icon;


            if (!icon) {
                return false;
            }

            if (icon && icon.imageUrl) {
                return React.createElement(
                    'i',
                    { className: 'admin-button__icon  material-icons' },
                    React.createElement('img', { src: icon.imageUrl, alt: '' })
                );
            }

            return React.createElement(
                'i',
                { className: 'admin-button__icon  material-icons' },
                icon
            );
        }, _this.renderLabel = function () {
            var title = _this.props.title || _this.props.label || false;

            if (!title) {
                return false;
            }

            return React.createElement(
                'i',
                { className: 'admin-button__label' },
                title
            );
        }, _this.renderToggle = function () {
            var onToggle = _this.props.onToggle;


            if (!onToggle) {
                return false;
            }

            return React.createElement(
                'div',
                { className: 'admin-button__toggle  material-icons' },
                'arrow_drop_down'
            );
        }, _this.getClassName = function () {
            var _this$props = _this.props,
                buttonType = _this$props.buttonType,
                type = _this$props.type,
                className = _this$props.className;


            if (!buttonType && type) {
                buttonType = type;
            }

            if (className) {
                return className;
            }

            var classNames = [];

            classNames.push("admin-button");

            if (buttonType) {
                classNames.push("admin-button--" + buttonType);
            }

            return classNames.join(' ');
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    Button.prototype.render = function render() {
        var _props = this.props,
            intlLabel = _props.intlLabel,
            style = _props.style,
            url = _props.url,
            value = _props.value,
            role = _props.role,
            controls = _props.controls,
            tabindex = _props.tabindex,
            selected = _props.selected,
            expanded = _props.expanded,
            disabled = _props.disabled,
            haspopup = _props.haspopup,
            target = _props.target,
            onClick = _props.onClick,
            onToggle = _props.onToggle,
            onUpload = _props.onUpload,
            onMouseDown = _props.onMouseDown;


        if (this.context.intl && intlLabel) {
            return React.createElement(ButtonIntl, this.props);
        }

        var className = this.getClassName();

        if (onUpload) {

            return React.createElement(ButtonUpload, this.props);
        }

        if ((url || onClick) && onToggle) {
            return React.createElement(
                'div',
                { className: className, style: style,
                    'aria-selected': selected,
                    'aria-haspopup': haspopup,
                    'aria-expanded': expanded },
                React.createElement(Button, _extends({}, this.props, { className: false, children: false, haspopup: false, expanded: false, selected: false, onToggle: undefined })),
                React.createElement(
                    'div',
                    { className: 'admin-button__toggle  material-icons', onClick: onToggle },
                    'arrow_drop_down'
                )
            );
        }

        if (url) {
            return React.createElement(
                Link,
                { to: url, className: className, style: style, onClick: onClick, target: target,
                    tabIndex: tabindex,
                    controls: controls,
                    haspopup: haspopup,
                    selected: selected,
                    expanded: expanded },
                this.renderIcon(),
                this.renderLabel(),
                this.props.children
            );
        }

        if (onToggle) {
            return React.createElement(
                'button',
                { className: className, style: style, onClick: onToggle,
                    value: value,
                    disabled: disabled,
                    'aria-haspopup': haspopup,
                    'aria-selected': selected,
                    'aria-expanded': expanded },
                this.renderIcon(),
                this.renderLabel(),
                this.renderToggle(),
                this.props.children
            );
        }

        return React.createElement(
            'button',
            { className: className, style: style, onClick: onClick, onMouseDown: onMouseDown, onToggle: onToggle,
                tabIndex: tabindex,
                role: role,
                value: value,
                disabled: disabled,
                'aria-controls': controls,
                'aria-haspopup': haspopup,
                'aria-selected': selected,
                'aria-expanded': expanded },
            this.renderIcon(),
            this.renderLabel(),
            this.props.children
        );
    };

    return Button;
}(React.Component), _class.contextTypes = { intl: PropTypes.object }, _temp2);


export default Button;